const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'demo',
  tiles: {
    blocker: 0,
    brick_brown0: 1,
    brick_dark0: 2,
    brick_dark3: 3,
    brick_dark4: 4,
    brick_dark5: 5,
    cobble_blood1: 6,
    cobble_blood10: 7,
    crystal_wall11: 8,
    dngn_blood_fountain: 9,
    dngn_blood_fountain2: 10,
    dngn_closed_door: 11,
    dngn_enter_dis: 12,
    dngn_enter_shop: 13,
    dngn_enter_tartarus: 14,
    dngn_locked_door: 15,
    dngn_mirrored_wall: 16,
    dngn_open_door: 17,
    dngn_open_sea: 18,
    dngn_open_sea2: 19,
    dngn_return_zot: 20,
    grey_dirt0: 21,
    lair0: 22,
    marble_wall7: 23
  },
  uidata: {
    rects: [
      vec4(8/1024,8/128,40/1024,40/128),
      vec4(56/1024,8/128,88/1024,40/128),
      vec4(104/1024,8/128,136/1024,40/128),
      vec4(152/1024,8/128,184/1024,40/128),
      vec4(200/1024,8/128,232/1024,40/128),
      vec4(248/1024,8/128,280/1024,40/128),
      vec4(296/1024,8/128,328/1024,40/128),
      vec4(344/1024,8/128,376/1024,40/128),
      vec4(392/1024,8/128,424/1024,40/128),
      vec4(440/1024,8/128,472/1024,40/128),
      vec4(488/1024,8/128,520/1024,40/128),
      vec4(536/1024,8/128,568/1024,40/128),
      vec4(584/1024,8/128,616/1024,40/128),
      vec4(632/1024,8/128,664/1024,40/128),
      vec4(680/1024,8/128,712/1024,40/128),
      vec4(728/1024,8/128,760/1024,40/128),
      vec4(776/1024,8/128,808/1024,40/128),
      vec4(824/1024,8/128,856/1024,40/128),
      vec4(872/1024,8/128,904/1024,40/128),
      vec4(920/1024,8/128,952/1024,40/128),
      vec4(968/1024,8/128,1000/1024,40/128),
      vec4(8/1024,56/128,40/1024,88/128),
      vec4(56/1024,56/128,88/1024,88/128),
      vec4(104/1024,56/128,136/1024,88/128)
    ]
  },
  layers: undefined,
  FRAME_BLOCKER: 0,
  FRAME_BRICK_BROWN0: 1,
  FRAME_BRICK_DARK0: 2,
  FRAME_BRICK_DARK3: 3,
  FRAME_BRICK_DARK4: 4,
  FRAME_BRICK_DARK5: 5,
  FRAME_COBBLE_BLOOD1: 6,
  FRAME_COBBLE_BLOOD10: 7,
  FRAME_CRYSTAL_WALL11: 8,
  FRAME_DNGN_BLOOD_FOUNTAIN: 9,
  FRAME_DNGN_BLOOD_FOUNTAIN2: 10,
  FRAME_DNGN_CLOSED_DOOR: 11,
  FRAME_DNGN_ENTER_DIS: 12,
  FRAME_DNGN_ENTER_SHOP: 13,
  FRAME_DNGN_ENTER_TARTARUS: 14,
  FRAME_DNGN_LOCKED_DOOR: 15,
  FRAME_DNGN_MIRRORED_WALL: 16,
  FRAME_DNGN_OPEN_DOOR: 17,
  FRAME_DNGN_OPEN_SEA: 18,
  FRAME_DNGN_OPEN_SEA2: 19,
  FRAME_DNGN_RETURN_ZOT: 20,
  FRAME_GREY_DIRT0: 21,
  FRAME_LAIR0: 22,
  FRAME_MARBLE_WALL7: 23
};
spritesheetRegister(module.exports);
